// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__31Zlr"};